import React, { useEffect, useState, useRef } from 'react';

const ChatBot = ({ onClose, chatColor, questionAnswersApi }) => {
  const messagesEndRef = useRef(null);

  // ✅ Move these two ABOVE useState
  // let questionAnswers = {
  //   '1. How can I add a new check-in?':
  //     'Click the red “+ ADD” button in the top right corner. You’ll be directed to a form to enter new guest details and assign a room.',
  //   '2. How do I search for a guest?':
  //     'Use the search bar on the top right of the table. You can search by guest name, room number, or mobile number inside check in.',
  //   '3. How can I add more guests under the same booking?':
  //     'Use the “Add” button in the Room Details section to insert additional rows for more guests (Male, Female, Child).',
  //   '4. What does the “Complimentary” checkbox do?':
  //     'If checked, it indicates the room or service is complimentary, possibly due to offers, corporate bookings, or special cases.',
  //   '5. How do I add a service item to the bill?':
  //     'Select a service item from the dropdown in Service page, enter the quantity, rate, applicable CGST & SGST percentages, any discount amount, and then click the green Add button.',
  //   '6. What is the purpose of the Service Deposit Management screen?':
  //     'This screen is used to create and manage service deposit bills for guests, covering charges for additional services availed during their stay.',
  //   '7. When should I use the "Change Occupancy Management" form?':
  //     'Use this form when a guest wants to add additional guests.',
  //   '8. Can I book rooms for future dates?':
  //     'Yes, just select the desired Booking Date and Checkout Date using the calendar pickers.',
  //   '9. How do I perform a guest check-out in the system?':
  //     'Go to the “Check Out Management” screen, verify check-out date/time, room and guest details, select the payment mode, review the final amount including any services used, and click SAVE to complete the process.',
  //   '10. How do I shift a guest to a different room in the system?':
  //     'Navigate to the “Room Shifting Management” screen, select the current Room No., input the arrival and shifted dates, choose the new room under “Shifted to,” and update the tariff plan and rate. Click SAVE to confirm the room shift.'
  // };
  let questionAnswers = questionAnswersApi;

  function getQuestionList() {
    return {
      sender: 'bot',
      text: 'Please choose a question below:',
      type: 'options',
      options: Object.keys(questionAnswers)
    };
  }

  // ✅ Initialize empty; populate after API data arrives
  let [messages, setMessages] = useState([]);
  let [Color, setColor] = useState("");

  useEffect(() => {
    if (questionAnswersApi && Object.keys(questionAnswersApi).length > 0) {
      setColor(chatColor);
      setMessages([
        { sender: 'bot', text: "Hi, I'm your assistant \uD83D\uDC4B" },
        getQuestionList()
      ]);
    }
  }, [questionAnswersApi]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleOptionSelect = (option) => {
    const userMessage = { sender: 'user', text: option };
    setMessages((prev) => [...prev, userMessage]);
    setLoading(true);

    setTimeout(() => {
      let newMessages = [];

      if (option === '🔙 Back') {
        newMessages = [getQuestionList()];
      } else {
        const answer = questionAnswers[option] || 'Sorry, I don’t have an answer for that.';
        newMessages = [
          { sender: 'bot', text: answer },
          {
            sender: 'bot',
            type: 'options',
            options: ['🔙 Back']
          }
        ];
      }

      setMessages((prev) => [...prev, ...newMessages]);
      setLoading(false);
    }, 500);
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '0%',
        right: '0%',
        width: '320px',
        height: '450px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 999
      }}
    >
      <div
        style={{
          padding: '10px',
          backgroundColor: Color,
          color: '#fff',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Hotel Assistant 🏨</span>
       
      </div>

      <div style={{ flex: 1, padding: '10px', overflowY: 'auto' }}>
        {messages.map((msg, index) => (
          <div
            key={index}
            style={{
              textAlign: msg.sender === 'user' ? 'right' : 'left',
              marginBottom: '8px'
            }}
          >
            {msg.type === 'options' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {msg.options.map((opt, i) => (
                  <button
                    key={i}
                    onClick={() => handleOptionSelect(opt)}
                    style={{
                      alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                      backgroundColor: '#f1f0f0',
                      border: '1px solid #ccc',
                      borderRadius: '10px',
                      padding: '6px 12px',
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    {opt}
                  </button>
                ))}
              </div>
            ) : (
              <span
                dangerouslySetInnerHTML={{ __html: msg.text }}
                style={{
                  display: 'inline-block',
                  padding: '8px 12px',
                  backgroundColor: msg.sender === 'user' ? '#DCF8C6' : '#f1f0f0',
                  borderRadius: '15px',
                  maxWidth: '80%'
                }}
              />
            )}
          </div>
        ))}
        {loading && (
          <div style={{ textAlign: 'left', marginBottom: '8px' }}>
            <span
              style={{
                display: 'inline-block',
                padding: '8px 12px',
                backgroundColor: '#f1f0f0',
                borderRadius: '15px',
                fontStyle: 'italic'
              }}
            >
              Typing...
            </span>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ChatBot;
